import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { breakpoints, colors, spacing } = theme.busbud;

  return {
    container: {
      marginTop: spacing(3),

      [breakpoints.up("md")]: {
        "&:before": {
          content: "''",
          marginBottom: spacing(3),
          height: "1px",
          backgroundColor: colors.border.primary.opaque,
          display: "block"
        }
      }
    }
  };
});
